import React, {
    useEffect,
    useState
} from 'react';
import {useTranslation} from "react-i18next";
import Divider from "@material-ui/core/Divider";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Dialog from "@material-ui/core/Dialog";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import CloseIcon from '@material-ui/icons/Close';
import List from "@material-ui/core/List";
import Slide from "@material-ui/core/Slide";
import CameraEventView from "./CameraEventView";
import ParkingEventRepository from "../../../repositories/ParkingEventRepository";
import Grid from "@material-ui/core/Grid";
import {formatDateTime, formatSeconds} from "../../../utils/Formatter";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ParkingEventDetailView = ({id, onClose}) => {

	const {t}  = useTranslation();
    const classes = useStyles();
    const [eventData, setEventData] = useState(null);
    const repository = new ParkingEventRepository();

    const handleClose = () => {
        if (onClose) {
            onClose({ id : id });
        }
    };

    useEffect(() => {

      async function fetchData() {

          try {
              const rs = await repository.getById(id);
              setEventData(rs.data);
          } catch (e) {
              handleClose();
          }
      }

      fetchData();

    }, [id]);

	return (
       <Dialog fullWidth={true} maxWidth={"lg"} open={true} onClose={handleClose} TransitionComponent={Transition}>
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" className={classes.title}>
                {t('Parking event')}
            </Typography>
          </Toolbar>
        </AppBar>
        {eventData &&
        <>
            <Grid container>
                <Grid item xs={12} lg={4}>
                    <List className="condensedList">
                      <ListItem>
                        <ListItemText primary={t('Number plate')} secondary={eventData.NumberPlate} />
                      </ListItem>
                      <ListItem>
                        <ListItemText primary={t('Number plate origin')} secondary={eventData.NumberPlateOrigin} />
                      </ListItem>
                   </List>
                </Grid>

                <Grid item xs={12} lg={4}>
                   <List className="condensedList">
                      <ListItem>
                        <ListItemText primary={t('Parking started')} secondary={formatDateTime(eventData.EntryDate)} />
                      </ListItem>
                      <ListItem>
                        <ListItemText primary={t('Parking finished')} secondary={formatDateTime(eventData.ExitDate)} />
                      </ListItem>
                   </List>
                </Grid>
            </Grid>

            <Grid container>
                <Grid item
                      xl={6}
                      xs={12}>
                        <Card>
                            <CardHeader title="Entrace" />
                            <Divider />
                            <CameraEventView imageUrl={eventData.EntryFullImageUrl} numberPlateImageUrl={eventData.EntryNumberPlateImageUrl}  />
                        </Card>
                </Grid>
                <Grid item
                      xl={6}
                      xs={12}>
                    <Card>
                        <CardHeader title="Exit" />
                        <Divider />
                        <CameraEventView imageUrl={eventData.ExitFullImageUrl} numberPlateImageUrl={eventData.ExitNumberPlateImageUrl}  />
                    </Card>
                </Grid>
            </Grid>
        </>
        }
      </Dialog>
	);
};

export default ParkingEventDetailView;